import { axiosClient } from '../../axiosClient';
import type { AccountMetric } from '../types';

type Params = {
  agentId: number;
};

export const getAgentMetrics = ({ agentId }: Params) =>
  axiosClient.get<AccountMetric[]>(`/dashboard-metric/${agentId}`);
